export const SETUP_USER_BEGIN = "SETUP_USER_BEGIN";
export const UPDATE_USER_BEGIN = "UPDATE_USER_BEGIN";
export const SETUP_USER_SUCCESS = "SETUP_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const SETUP_USER_ERROR = "SETUP_USER_ERROR";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const GET_USERS_BEGIN = "GET_USERS_BEGIN";
export const GET_USERS_SUCCESS ="GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";
